import { render, staticRenderFns } from "./driver-info.vue?vue&type=template&id=73fb88f8&scoped=true&"
import script from "./driver-info.vue?vue&type=script&lang=js&"
export * from "./driver-info.vue?vue&type=script&lang=js&"
import style0 from "./driver-info.vue?vue&type=style&index=0&id=73fb88f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fb88f8",
  null
  
)

export default component.exports